import crystall51 from "../../../media/ruko/rukol5/crystall51.png";
import crystall52 from "../../../media/ruko/rukol5/crystall52.png";
import crystall53 from "../../../media/ruko/rukol5/crystall53.png";
import crystall54 from "../../../media/ruko/rukol5/crystall54.png";
import crystall55 from "../../../media/ruko/rukol5/crystall55.png";
import crystall56 from "../../../media/ruko/rukol5/crystall56.png";
import crystall57 from "../../../media/ruko/rukol5/crystall57.png";
import crystall58 from "../../../media/ruko/rukol5/crystall58.png";

const crystall5images = [
  crystall51,
  crystall52,
  crystall53,
  crystall54,
  crystall55,
  crystall56,
  crystall57,
  crystall58,
];

export default crystall5images;
